import React, { Component, Suspense } from 'react';
import { Container } from 'reactstrap';
import _ from 'lodash';
import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav
} from '@coreui/react';
import { connect } from 'react-redux';

import { defaultProps } from 'recompose';

import sidebarImage from "../../../assets/img/backgrounds/victor-garcia-682037-unsplash.jpg";


import $ from 'jquery';
const AdminAside = React.lazy(() => import('./AdminAside'));
const Footer = React.lazy(() => import('../common/Footer'));
const AdminHeader = React.lazy(() => import('./AdminHeader'));


class AdminSidebarMinimizer extends Component {
  componentWillReceiveProps(nextProps){
    if (nextProps.isOpen !== this.props.isOpen){
      const bodyClass = 'sidebar-minimized brand-minimized';

      if (nextProps.isOpen){
        return $(document.body).removeClass(bodyClass);
      }
      return $(document.body).addClass(bodyClass);
    }
  }

  render(){
    return (
      <button onClick={this.props.onClick} className="sidebar-minimizer mt-auto" type="button">{this.props.isOpen}</button>
    )
  }
}

class AdminLayout extends Component {
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">
      <div className="sk-spinner sk-spinner-pulse" />
    </div>
  );

  render() {

    const sidebarConf = _.filter(this.props.navConfig, (navConf) => {
      if (_.isNil(navConf.userType)){
        return true;
      }
      if (_.isArray(navConf.userType)){
        const i = _.findIndex(navConf.userType, (el) => _.isEqual(this.props.userType, el));
        return i > -1;
      }

      return _.isEqual(navConf.userType, this.props.userType)
    });

    return (
      <div className="app admin">
        <AppHeader fixed>
          <Suspense fallback={this.loading()}>
            <AdminHeader
              user={this.props.user}
              isAuthenticated={this.props.isAuthenticated}
              onLogout={this.props.onLogout}
            />
          </Suspense>
        </AppHeader>

        <div className="app-body">
          <AppSidebar
            fixed
            display="lg"
            style={{backgroundImage: `url(${sidebarImage})`}}
          >
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense>
              <AppSidebarNav navConfig={{ items: sidebarConf }} />
            </Suspense>
            <AppSidebarFooter />
            <AdminSidebarMinimizer
              isOpen={this.props.layout.sidebar}
              onClick={() => this.props.dispatch({ type:'SET_LAYOUT', value: { sidebar: !this.props.layout.sidebar } })}
            />
          </AppSidebar>

          <main className="main d-flex flex-column">
            <AppBreadcrumb
              className='flex-grow-0 flex-shrink-1'
              style={{ flexBasis: 'auto' }}
              appRoutes={this.props.routes}
            />

            <Container fluid className='flex-grow-1 d-flex flex-column align-items-stretch h-100'>
              <Suspense fallback={this.loading()}>
                {this.props.children}
              </Suspense>
            </Container>
          </main>


          <AppAside fixed>
            <Suspense fallback={this.loading()}>
              <AdminAside />
            </Suspense>
          </AppAside>


        </div>

        <AppFooter>
          <Suspense fallback={this.loading()}>
            <Footer />
          </Suspense>
        </AppFooter>
      </div>
    );
  }
}

const withDefaults = defaultProps({
  routes: [],
  navigation: { items: [] }
});

export default connect((state) => ({ layout: state.layout }))(withDefaults(AdminLayout));
